export default __webpack_public_path__ + "static/media/brain.5e613df2.png";